import React, { useEffect, useRef, useState } from "react";
import './VideoPlayer.css';

interface IVideoPlayerProps{
    videoUrl?: string;
    selectedTime: number;
    onTimeUpdate?: (time: number)=>void
}

export const VideoPlayer = ({videoUrl, selectedTime, onTimeUpdate}: IVideoPlayerProps)=>{
    const videoRef = useRef<HTMLVideoElement>(null);
    const [isPlaying, setPlaying] = useState(false);
    const [isAudio, setIsAudio] = useState<boolean>(null);

    useEffect(()=>{
        if (!videoRef.current){
            return;
        }
        videoRef.current.currentTime = selectedTime;
    }, [selectedTime, videoRef.current]);

    return (
        <div className={`videoPlayer ${isAudio ? 'videoPlayer--isAudio': ''}`}>
            <video style={{display: 'none'}} src={videoUrl || null} onCanPlay={(e)=>{
                if ((e.target as HTMLVideoElement).videoHeight){
                    setIsAudio(false);
                } else {
                    setIsAudio(true);
                }
            }}> </video>
            <div className="videoPlayer_video">
                {isAudio === false &&
                <>
                <video ref={videoRef} controls={isPlaying} className="videoPlayer_video_element" src={videoUrl || null} onTimeUpdate={()=>onTimeUpdate?.(videoRef.current.currentTime)}></video>
                {!isPlaying && <div className="videoPlayer_overlay">
                    <div className="button videoPlayer_playButton" onClick={()=>{
                        setPlaying(true);
                        videoRef.current.play();
                    }}>
                        Play
                    </div>
                </div>}
                </> 
                }
                {isAudio === true && <audio ref={videoRef} controls={true} className="videoPlayer_audio_element" src={videoUrl || null} onTimeUpdate={()=>onTimeUpdate?.(videoRef.current.currentTime)}></audio>
                }
            </div>
        </div>
    )
}
